import React, { useEffect, useState } from 'react'

import { Col, Row, Table, Popconfirm, message, Button, PageHeader, Empty } from 'antd'

import { useNavigate, useLocation  } from 'react-router-dom'

import { MiniLoader, Loader, downloadFile } from '../utility/componentUtility'

import doUtility from '../utility'

import { DownloadOutlined } from '@ant-design/icons'

import illustrationsStore from '../../store/slice/illustration.slice'

function IllustrationDetails () {
    const navigate = useNavigate()

	const IllustrationInFolders     = illustrationsStore((state) => state.IllustrationInFolders)
    const getIllustrationInFolders  = illustrationsStore((state) => state.getIllustrationInFolders)
    const downloadIllustration      = illustrationsStore((state) => state.downloadIllustration)

    const illustrationFolderId      = illustrationsStore((state) => state.illustrationFolderId)

    useEffect(()=>{
        if(IllustrationInFolders == null){
            getIllustrationInFolders(illustrationFolderId.id)
        }
    }, [ illustrationFolderId ])

    const [SelectRecord, changeSelectedRecord] = useState([])

    const [loading, setLoading] = useState(false)

    const confirm = async (e) => {
        setLoading(true)
        await downloadIllustration(SelectRecord.id).then((r)=>{
            //if(r.data.Format == 'EXCEL'){
                const FileName = SelectRecord.name.replaceAll(' ', '_')
                downloadFile("", r.data.responseUtility, FileName);
                //downloadXLSX(r.data.responseUtility, FileName)
            // /}
            setLoading(false)
            message.info('Downloading Completed...', 2.5)
        })
    }

    const action = {
        title: 'Action',
        key: 'action',
        render: (_, record) => (
            <Popconfirm title="Please Confirm To Download ?" onConfirm={confirm}>
                <Button type="default" icon={<DownloadOutlined />} onClick={ () => { changeSelectedRecord(record) } }>
                </Button>
            </Popconfirm>
        )
    }

    return(
        <Row>
            {loading ? <Loader /> : ''}

            <PageHeader
                className="site-page-header"
                onBack={() => navigate(-1)}
                title="Detail View - "
                subTitle={illustrationFolderId.name}
            />
            
            {IllustrationInFolders == 'loading' ? <Loader /> : ''}

            <Col md={24}>
               {( () => {

                    console.log(IllustrationInFolders)
                    if (IllustrationInFolders && IllustrationInFolders.length > 0) {
                        if(IllustrationInFolders === 'loading'){
                            return (
                                <MiniLoader />
                            )
                        }else{
                            
                            const IllustrationInFolders_list = doUtility.RenderTableData(IllustrationInFolders)

                            const column = IllustrationInFolders_list.column.filter(function(item) {
                                if(item.dataIndex == 'id' ){
                                    return false
                                }else{
                                    return true
                                }
                            });
                                            
                            return (
                                <>
                                    <a href="#" id="dwnlink"></a>

                                    <Table
                                        className='back-white p10' 
                                        style={{ margin: 'auto', borderRadius: '2px'}} 
                                        dataSource={IllustrationInFolders_list.datasource} columns={[...column, action]} />
                                </>
                            )
                        }
                    }else{
                        return (
                            <Empty />
                        )
                    }
                }) ()}
            </Col>
        </Row>
        
    )
}

const downloadXLSX = (pdf, file_name="donwload.xlsx") => {
    const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${pdf}`
    //const linkSource = `data:application/vnd.ms-excel;base64,${pdf}`
    //application/vnd.ms-excel
    const downloadLink = document.createElement("a")
    downloadLink.href = linkSource
    downloadLink.setAttribute('download', file_name);
    downloadLink.target = "_blank"
    downloadLink.click()
}

export default IllustrationDetails;